import React from 'react';
import Button from '@saucelabs/sl-component-buttons';

import Styles from './SeeAllButton.styles';

const SeeAllButton = () => (
  <div className={Styles.default}>
    <Button
      category="primary"
      href="/archives"
      withArrow
    >
      See all in Archives
    </Button>
  </div>
);

export default SeeAllButton;
